import React, { Component } from "react";
import { Box, Typography, Button, Divider,Select,FormControl,MenuItem } from '@mui/material';
// import access1 from '../../../images/Comet/exter1.webp';
// import access2 from '../../../images/Comet/exter2.webp';
// import access3 from '../../../images/Comet/exter3.webp';
// import access4 from '../../../images/Comet/exter4.webp';
// import inte1 from '../../../images/Comet/inte1.webp';
// import inte2 from '../../../images/Comet/inte2.webp';
// import inte3 from '../../../images/Comet/inte3.webp';
// import inte4 from '../../../images/Comet/inte4.webp';
// import lit1 from '../../../images/Comet/lit1.webp';
// import lit2 from '../../../images/Comet/lit2.webp';
// import lit3 from '../../../images/Comet/lit3.webp';
// import lit4 from '../../../images/Comet/lit4.webp';
// import sticker1 from '../../../images/Comet/sticker1.webp';
// import sticker2 from '../../../images/Comet/sticker2.webp';
// import sticker3 from '../../../images/Comet/sticker3.webp';
// import sticker4 from '../../../images/Comet/sticker4.webp';
// import edition1 from '../../../images/Comet/edition1.webp';
// import edition2 from '../../../images/Comet/edition2.webp';
// import edition3 from '../../../images/Comet/edition3.webp';
// import edition4 from '../../../images/Comet/edition4.webp'

// const edition1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/COMET%20EV%2FEdition%2Fedition1.webp?alt=media&token=c65ad70a-332b-4a5a-97c8-8364c0cade56"
// const edition2 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/COMET%20EV%2FEdition%2Fedition2.webp?alt=media&token=ef41545b-6a76-4bef-9755-6a3867a05c00"
// const edition3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/COMET%20EV%2FEdition%2Fedition3.webp?alt=media&token=b092e02d-1bcf-4516-a84d-d4d2fedd84b2"
// const edition4 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/COMET%20EV%2FEdition%2Fedition4.webp?alt=media&token=79d95ab7-0022-47a8-84d7-cffc0e8e5b84"

const sticker1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-0145.webp?alt=media&token=c6c37904-f5b1-4940-ad65-c3600d87abd0"
const sticker2 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-0146.webp?alt=media&token=91636122-cb57-4e07-af90-3a5bbf5cf625"
const sticker3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-0147.webp?alt=media&token=d2614ffb-dd09-44d2-b6e9-4acc2497ca28"
const sticker4="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-0148.webp?alt=media&token=f3ff1883-074d-4297-81ab-21addc234d5d"

const lit1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-135.webp?alt=media&token=4e4b59f0-8205-4264-a980-47285db047da"
const lit2 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-136.webp?alt=media&token=87188eb6-aa1e-4e0f-9883-70326a60aa8a"
const lit3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-137.webp?alt=media&token=18443f2e-e0e7-4aca-bfec-449651c95318"
const lit4 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-138.webp?alt=media&token=3d10a6dd-3327-4f91-aa3b-a3bd10d719d5"

const inte1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-022.webp?alt=media&token=44ca6076-84ac-4942-a41b-5f272ea8aef8"
const inte2 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-0150.webp?alt=media&token=ae77a422-b96f-4981-97ce-1f5ea16472a9"
const inte3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-0151.jpg?alt=media&token=34bc2628-3f53-49c8-8c89-325b1b121399"
const inte4 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-0152.webp?alt=media&token=34847194-a770-4a54-af28-223dd3b0057f"

const access1 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-139.webp?alt=media&token=7e73b9bd-061f-4c62-b2f0-40a390745934"
const access2 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-140.webp?alt=media&token=eab3a492-59af-4656-b389-aa756e7bae17"
const access3 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-141.webp?alt=media&token=6997a730-96ed-4445-b9fb-b8ad5417f35c"
const access4 ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/comet-ev-electric%2Fcm-img-dsc-142.webp?alt=media&token=3b6ab6c9-ff4f-496a-b7ec-bf897db23185"
class Accessories extends Component {
  constructor(props) {
    super(props);
    this.state = {
  selectedTab: 'STICKERS', // default tab change
  screenSize: window.innerWidth,
  selectedImage: this.getTabImages('STICKERS')[0],
};

  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ screenSize: window.innerWidth });
  };

  getTabImages = (tab) => {
    const tabData = {
      // "LIMITED EDITION" : [
      //   {
      //     src: edition1,
      //     label:'Exterior',
      //     title: 'Gamer Edition',
      //     subtitle: 'Exterior',
      //     description: 'Doesn’t it hit different when somebody matches your vibe? And MG Comet EV is just the car that will vibe with you because it’s the perfect partner in crime which brings out the fun side of you as you drive the car through the city.',
      //   },
      //   {
      //     src: edition2,
      //     label:'Steering Wheel Cover-Gamer',
      //     title: 'Gamer Edition',
      //     subtitle: 'Steering Wheel Cover-Gamer',
      //     description: 'Doesn’t it hit different when somebody matches your vibe? And MG Comet EV is just the car that will vibe with you because it’s the perfect partner in crime which brings out the fun side of you as you drive the car through the city.',
      //   },
      //   {
      //     src: edition3,
      //     label: 'Interior Inserts-Gamer',
      //     title:'Gamer Edition',
      //     subtitle: 'Interior Inserts-Gamer',
      //     description: 'Doesn’t it hit different when somebody matches your vibe? And MG Comet EV is just the car that will vibe with you because it’s the perfect partner in crime which brings out the fun side of you as you drive the car through the city.',
      //   },
      //   {
      //     src: edition4,
      //     label: 'Body Graphics-Gamer',
      //     title:'Gamer Edition',
      //     subtitle: 'Body Graphics-Gamer',
      //     description: 'Doesn’t it hit different when somebody matches your vibe? And MG Comet EV is just the car that will vibe with you because it’s the perfect partner in crime which brings out the fun side of you as you drive the car through the city.',
      //   }
      // ],
     STICKERS: [
        {
          src: sticker1,
          label:'Blossom',
          title: 'Stickers',
          subtitle: 'Blossom',
          description: 'Make a Statement With Your Car.',
        },
        {
          src: sticker2,
          label:'Emoticon',
          title: "Stickers",
          subtitle: 'Emoticon',
          description: 'Make a Statement With Your Car.',
        },
        {
          src: sticker3,
          label:'Floresta',
          title: 'Stickers',
          subtitle: 'Floresta',
          description: 'Make a Statement With Your Car.',
        },
        {
          src: sticker4,
          label:'Night Cafe',
          title: 'Stickers',
          subtitle: 'Night Cafe',
          description: 'Make a Statement With Your Car.',
        }
      ],
      "LIT PACKS":[
        {
          src: lit1,
          label:'Serenity Lush Pack',
          title: 'Lit-Packs',
          subtitle: 'Serenity Lush Pack',
          description: 'Colour Kit Pack.',
        },
        {
          src: lit2,
          label:'Sundowner Lush Pack',
          title: 'Lit-Packs',
          subtitle: 'Sundowner Lush Pack',
          description: 'Colour Kit Pack.',
        },
        {
          src: lit3,
          label:'Flex Lush Pack',
          title: 'Lit-Packs',
          subtitle: 'Flex Lush Pack',
          description: 'Colour Kit Pack.',
        },
        {
          src: lit4,
          label:'Beach Bae Lush Pack',
          title: 'Lit-Packs',
          subtitle: 'Beach Bae Lush Pack',
          description: 'Colour Kit Pack.',
        },
      ],
      EXTERIORS: [
        {
          src: access1,
          label:'Body side moulding',
          title: 'Exterior',
          subtitle: 'Body side moulding',
          description: 'These high quality chrome insert claddings protect the paint job as well as maintains the premium look of your Comet.',
        },
        {
          src: access2,
          label:'Hood Branding',
          title: 'Exterior',
          subtitle: 'Hood Branding',
          description: 'The high quality additions to compliment your car that are bound to turn heads. Specifically designed to add shine and glamour, it comes with high grade chrome quality finish and is very easy to apply.',
        },
        {
          src: access3,
          label: 'Hood Garnish',
          title:'Exterior',
          subtitle: 'Hood Garnish',
          description: 'The high quality additions to compliment your car that are bound to turn heads. Specifically designed to add shine and glamour, it comes with high grade chrome quality finish.',
        },
        {
          src: access4,
          label: 'Integrated Roof Carrier',
          title:'Exterior',
          subtitle: 'Integrated Roof Carrier',
          description: 'Made from High Quality plastic and aluminum making it light in weight. Modern and unique design with precision fitment makes it an integrated part of the Vehicle. Load bearing capacity is of 60kgs.',
        }
      ],
    
      INTERIORS: [
        {
          src: inte1,
          label:'10.25" Integrated Floating Widescreen',
          title: 'Interior',
          subtitle:'10.25" Integrated Floating Widescreen',
          description: 'This car will never cramp your style because it has all it takes to make every drive a TLC session. And one look at its plush, luxurious interiors you’ll know it’s ‘gram worthy.',
        },
        {
          src: inte2,
          label:'Interior Inserts',
          title: "Interior",
          subtitle: 'Interior Inserts',
          description: 'Interior finishes to offer rich and luxurious look to the car, Easy to install.',
        },
        {
          src: inte3,
          label:'Auxilery Battery Pack',
          title: 'Interior',
          subtitle: 'Auxilery Battery Pack',
          description: 'Portable battery station which can be used to charge devices under 300W, such as mini-fridges, TVs, and gaming consoles and perfect for outdoor adventures or emergency backup power.',
        },
        {
          src: inte4,
          label:'Interior Organiser – Front',
          title: 'Interior',
          subtitle: 'Interior Organiser – Front',
          description: 'Front adds extra storage and keeps items secure in your Comet EV.',
        }
      ],
    
    
    };
    
    return tabData[tab] || [];
  };

  handleTabChange = (tab) => {
    const images = this.getTabImages(tab);
    this.setState({
      selectedTab: tab,
      selectedImage: images[0],
    });
  };

  handleImageClick = (image) => {
    this.setState({ selectedImage: image });
  };

  renderContent = () => {
    const { selectedTab, selectedImage, screenSize } = this.state;
    const images = this.getTabImages(selectedTab);

    return (
      <Box sx={{ width: '80%', height: '100%',
    
      }}>
        <Box
          sx={{
            height: '90%',
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: { xs: 'center', md: 'space-around' },
            alignItems: { xs: 'center', md: 'start' },
            gap: '20px',
            flexWrap: 'no-wrap',
            marginLeft: { xs: '-5px', md: '0px' } ,
            marginTop:{xs:'15px'},
            
          }}
        >
          <img
            src={selectedImage.src}
            style={{
              borderRadius: '10px',
              width: '95vw',
              maxWidth: '500px',
              height: '280px',
              
            }}
            alt={selectedImage.title}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: {md:'space-around', xs:'start',sm:'start'},
              alignItems:'start',
              width: '100%',
              maxWidth: '500px',
              marginLeft: { xs: '-35px', md: '0px' } 
            }}
          >
            <Typography variant="h5"
              sx={{
                width: { xs: '90%', md: '330px' },
                fontFamily: 'GillSansRegular, Arial, sans-serif',
                color: '#000',
                fontSize: { xs: '4vw', md: '1.5625vw' },
                marginBottom: '12px',
              }}>
              {selectedImage.title}
            </Typography>
            <Typography
              sx={{
                width: { xs: '300px', md: '330px',sm:'100%' },
                fontFamily: 'Roboto-Regular, Arial, sans-serif',
                color: '#6e6e6e',
                fontSize: { xs: '3.5vw', md: '1.04167vw' ,sm:'2.5vw'},
                marginBottom: '12px',
              }}>
              {selectedImage.subtitle}
            </Typography>
            <Typography
              sx={{
                width: { xs: '270px', md: '350px',sm:'550px' },
                fontFamily: 'Roboto-Regular, Arial, sans-serif',
                fontSize: { xs: '3.5vw', md: '1.04167vw',sm:'2.1vw' },
                color: '#000',
                marginBottom: '2.08333vw',
                paddingTop: '1.30208vw',
              }}>
              {selectedImage.description}
            </Typography>
          </Box>
        </Box>
        <Box
  sx={{
    display: 'flex',
    flexDirection: 'row',
    alignItems: { xs: 'center', md: 'flex-start' },
    gap: '10px',
    marginTop: { xs: '30px', md: '50px' },
    marginLeft: { xs: '-25px', md: '0px' } 
  }}
>
  {images.map((img, index) => (
    <Box
      key={index}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: { md: 'center', xs: 'start' }
      }}
    >
      <img
        src={img.src}
        style={{
          borderRadius: '10px',
          width: '20vw',
          maxWidth: '250px',
          height: 'auto',
          marginTop: { xs: '10px', md: '40px', sm: '20px' }
        }}
        alt={img.label}
        onClick={() => this.handleImageClick(img)}
      />
      <Typography
        sx={{
          fontFamily: 'Roboto-Medium, Arial, sans-serif',
          fontSize: { xs: '3.5vw', md: '1.04167vw' },
          color: '#000',
          paddingTop: '1.04167vw',
          margin: 0,
          display:{md:'flex',xs:'none'},
          textAlign: { xs: 'left', md: 'left' }, 
          width: '100%' 
        }}
      >
        {img.label}
      </Typography>
    </Box>
  ))}
</Box>

      </Box>
    );
  };

  render() {
    const { selectedTab, screenSize } = this.state;
    const tabs = ['STICKERS', 'LIT PACKS','INTERIORS','EXTERIORS'];

    return (
      <Box
        id="features"
        sx={{
          height: 'auto',
          width: '100%',
          minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: { xs: '20px', md: '0' }, 
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '6vw', md: '2.08333vw' },
            color: '#cf2230',
            fontFamily: 'Gill Sans, Gill Sans MT, Calibri, sans-serif',
            paddingBottom: '3.125vw',
            fontWeight: '400',
            marginTop: '15px',
          }}
        >
          ACCESSORIES
        </Typography>

        {screenSize <= 768 ? (
          <FormControl fullWidth sx={{ width: '80%', marginBottom: '20px' }}>
            <Select
              style={{fontWeight:'700'}}
              value={selectedTab}
              onChange={(e) => this.handleTabChange(e.target.value)}
              displayEmpty
              inputProps={{ 'aria-label': 'Tab Selection' }}
            >
              {tabs.map((tab) => (
                <MenuItem key={tab} value={tab}>
                  {tab}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <Box
            sx={{
              height: '15px',
              width: '75%',
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center',
              gap: '50px',
            }}
          >
            {tabs.map((tab) => (
              <Button
                key={tab}
                onClick={() => this.handleTabChange(tab)}
                sx={{
                  fontFamily: 'GillSansRegular, Arial, sans-serif',
                  fontSize: { xs: '4vw', md: '1.25vw' },
                  color:'black',
                  fontWeight: selectedTab === tab ? 'bolder' : '500',
                  backgroundColor: selectedTab === tab ? '#B9E170' : 'transparent',
                  '&:hover': {
                    backgroundColor: '#B9E170',
                  },
                }}
              >
                {tab}
              </Button>
            ))}
          </Box>
        )}

        <Divider sx={{ width: '80%', display: { md: 'flex', xs: 'none' }, border: '4px solid #B9E170', margin: '20px 0' }} />

        {this.renderContent()}
      </Box>
    );
  }
}

export default Accessories;
